module.exports = __webpack_public_path__ + "static/media/enexl.b1ba73f4.png";